import React, { useState, useEffect } from 'react';
import HeaderForm from './headerform';
import { Link } from 'react-router-dom';
// import Footer from './footer';

import secureLocalStorage from "react-secure-storage";

function Instruction() {
    const [user, setUser] = useState(null);
    React.useEffect(() => {

        if (document.body.classList.contains('body_bg')) {
            document.body.classList.remove('body');

        }
        document.body.classList.add('body_bg');
        // console.log((secureLocalStorage.getItem('consentForm')));
        if ((secureLocalStorage.getItem('consentForm')) != null && (secureLocalStorage.getItem('consentForm')) != undefined) {

            setUser((secureLocalStorage.getItem('consentForm')));
        }
    }, []);
    return (
        <>
            <HeaderForm />
            <div className='regis-main-sec instruction-sec'>
                <div className='container-fluid'>

                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='regis-head'>
                                <h2>INSTRUCTIONS FOR SPORTS PHYSICALS


                                </h2>

                            </div>
                        </div>
                    </div>

                    <div className='regis-form-sec otp-main-sec instruction-main-sec'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <p>Parent/Guardian must complete and sign the history form. Please answer all questions. Student must sign the form as well.
                                    Parent/Guardian must complete and sign the supplemental forms.Student must sign as well.</p>

                                <p>If you child has asthma, your physician must complete the asthma treatment plan.</p>
                                <p>The parent and student must sign the consent forms for permission to play, random drug screening, concussion education acknowledgement
                                    and opioid fact sheet. </p>
                                <p>Please sign the parent/guardian acknowledgement form for Sudden Cardiac Death <br />
                                    and retain the brochure for your records.
                                    {/* - <span className='down-sec'>DOWNLOAD</span> */}
                                </p>
                                <p className='incom-sec'>ANY INCOMPLETE FORMS WILL BE RETURNED</p>
                                {user != null ?

                                    <>
                                        {(user.status != 'Approved' && user.status != 'Rejected') &&
                                            <Link to="/forms" className='go-form-sec'>Go to Form Console</Link>

                                        }
                                        {(user.status == 'Approved' || user.status == 'Rejected') &&
                                            <Link to="/formstatus" className='go-form-sec'>Go to Form Console</Link>

                                        }

                                    </>
                                    :
                                    <Link to="/forms" className='go-form-sec'>Go to Form Console</Link>
                                }


                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* <Footer /> */}
        </>
    )
}
export default Instruction;

